import { ReactNode } from 'react';
import { useAuth } from '@/contexts/auth';
import type { AccessRole } from '@/constants/rbac';
import { getAccessRole } from '@/utils/rbac';

type CanAccessProps = {
  roles: AccessRole[];
  children: ReactNode;
  fallback?: ReactNode;
};

export const CanAccess = ({ roles, children, fallback = null }: CanAccessProps) => {
  const { user } = useAuth();
  const role = getAccessRole(user);

  if (!roles.includes(role)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
